import { IEntity } from "@/entity/shared/EntityStoreTypes";
import { entityApi } from "@/wapi/entity-api";
import { isCallValidAndNotCancelled } from "@t/ajax-wrapper";
import { action, createModule, mutation } from "vuex-class-component";

const VuexModule = createModule({
    namespaced: 'entity',
    strict: true
});

export class EntityStore extends VuexModule {
    private Entities: IEntity[] = [];
    private EntitiesLoaded: boolean = false;

    get entities(): IEntity[] { return this.Entities; }
    get entitiesLoaded(): boolean { return this.EntitiesLoaded; }

    @mutation
    setEntities(entities: IEntity[]): void {
        this.Entities = entities;
        this.EntitiesLoaded = true;
    }

    @mutation
    setEntitiesLoaded(entitiesLoaded: boolean): void {
        this.EntitiesLoaded = entitiesLoaded;
    }

    @mutation
    reset(): void {
        this.Entities = [];
        this.EntitiesLoaded = false;
    }

    @action
    public async fetchEntities(): Promise<void> {
        const entitiesCall = await entityApi.getAllBase();
        if (!isCallValidAndNotCancelled(entitiesCall)) return;
        const entities = entitiesCall?.datas as IEntity[];
        this.setEntities(entities);
        this.setEntitiesLoaded(false);
    }
}
